export enum PileStatus {
  Disposable = 'DISPOSABLE',
  PrePlanning = 'PRE_PLANNING',
  Locked = 'LOCKED',
  InRemoval = 'IN_REMOVAL',
}
